export const exchangeAssistantTypographyOverrideStyleId = "exchange-assistant-typography-override";

const exchangeAssistantTypographyOverrideCss = `
html,
body,
ai-assistant-mfe,
ai-assistant-mfe html,
ai-assistant-mfe body {
    font-size: 16px !important;
}
`;

function upsertTypographyOverrideStyle(parent: HTMLElement | ShadowRoot) {
    const existingStyle = parent.querySelector(`#${exchangeAssistantTypographyOverrideStyleId}`) as HTMLStyleElement | null;
    const styleElement = existingStyle ?? document.createElement("style");

    styleElement.id = exchangeAssistantTypographyOverrideStyleId;
    styleElement.textContent = exchangeAssistantTypographyOverrideCss;
    parent.appendChild(styleElement);
}

function forceRootFontSize(element: HTMLElement | null) {
    if (element != null) {
        element.style.fontSize = "16px";
    }
}

export function applyExchangeAssistantTypographyOverride(assistantElement: HTMLElement | null) {
    forceRootFontSize(document.documentElement);
    forceRootFontSize(document.body);

    if (document.head != null) {
        upsertTypographyOverrideStyle(document.head);
    }

    if (assistantElement == null) {
        return false;
    }

    forceRootFontSize(assistantElement);

    const lightDomHtmlElement = assistantElement.querySelector("html") as HTMLElement | null;
    const lightDomBodyElement = assistantElement.querySelector("body") as HTMLElement | null;
    forceRootFontSize(lightDomHtmlElement);
    forceRootFontSize(lightDomBodyElement);

    if (assistantElement.shadowRoot == null) {
        return false;
    }

    upsertTypographyOverrideStyle(assistantElement.shadowRoot);
    forceRootFontSize(assistantElement.shadowRoot.querySelector("html") as HTMLElement | null);
    forceRootFontSize(assistantElement.shadowRoot.querySelector("body") as HTMLElement | null);

    return true;
}
